import { render, staticRenderFns } from "./Xtrading.vue?vue&type=template&id=5e71f376&scoped=true"
import script from "./Xtrading.vue?vue&type=script&lang=js"
export * from "./Xtrading.vue?vue&type=script&lang=js"
import style0 from "./Xtrading.vue?vue&type=style&index=0&id=5e71f376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e71f376",
  null
  
)

export default component.exports